import { useAppDispatch, useAppSelector } from '@/app/redux/hooks';
import {
  closeConfirmationDialogue,
  getAndClearConfirmationDialogueCallback,
  selectModals,
} from '@/app/redux/slices/modalsSlice';
import { Button } from '@shadcn/components/button';
import { Checkbox } from '@shadcn/components/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';
import { Label } from '@shadcn/components/label';
import { cn } from '@shadcn/lib/utils';
import { useState } from 'react';

export default function ConfirmationDialogue() {
  const dispatch = useAppDispatch();
  const { confirmationDialogue } = useAppSelector(selectModals);

  const [loading, setLoading] = useState(false);
  const [optionSelected, setOptionSelected] = useState(
    confirmationDialogue?.checkboxOption?.default ?? false,
  );

  if (!confirmationDialogue) return null;

  const { title, description, checkboxOption, variant } = confirmationDialogue;

  const handleCancel = () => {
    dispatch(closeConfirmationDialogue());
  };

  const handleConfirm = async () => {
    setLoading(true);
    const onConfirm = getAndClearConfirmationDialogueCallback();
    if (onConfirm) {
      await onConfirm(optionSelected);
    }
    dispatch(closeConfirmationDialogue());
    setLoading(false);
  };

  return (
    <Dialog
      open={!!confirmationDialogue}
      onOpenChange={(open) => !open && dispatch(closeConfirmationDialogue())}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {description && (
          <DialogDescription
            className={cn(
              Array.isArray(description) ? 'flex flex-col gap-1' : '',
            )}
          >
            {Array.isArray(description)
              ? description.map((line, i) => <span key={i}>{line}</span>)
              : description}
          </DialogDescription>
        )}

        {checkboxOption && (
          <Label className="flex items-center gap-2">
            <Checkbox
              checked={optionSelected}
              onCheckedChange={(checked) =>
                setOptionSelected(checked === 'indeterminate' ? false : checked)
              }
            />
            <span className="text-sm">{checkboxOption.label}</span>
          </Label>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>
          <Button variant={variant} onClick={handleConfirm} loading={loading}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
